import { Injectable } from '@angular/core';
import { CRUDService } from '../../core/services/crud.service';
import { ActaEntregaEpp } from '../entities/acta-entrega-epp';
import { HttpInt } from 'src/app/httpInt';
import { MensajeUsuarioService } from '../../comun/services/mensaje-usuario.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActaEntregaEppService extends CRUDService<ActaEntregaEpp> {
  constructor(
    public override httpInt: HttpInt,
    public override mensajeUsuarioService: MensajeUsuarioService
  ) {
    super(httpInt, mensajeUsuarioService);
  }

  getClassName(): string {
    return "ActaEntregaEppService";
  }

  // Obtener actas por solicitud de EPP
  getActasBySolicitud(idSolicitudEpp: number): Promise<ActaEntregaEpp[]> {
    return new Promise((resolve, reject) => {
      this.httpInt.get(`${this.end_point}solicitud/${idSolicitudEpp}`)
        .subscribe(
          (res) => resolve(res as ActaEntregaEpp[]),
          (err) => {
            this.manageError(err);
            reject(err);
          }
        );
    });
  }

  // Obtener actas por empleado
  getActasByEmpleado(idEmpleado: number): Promise<ActaEntregaEpp[]> {
    return new Promise((resolve, reject) => {
      this.httpInt.get(`${this.end_point}empleado/${idEmpleado}`)
        .subscribe(
          (res) => resolve(res as ActaEntregaEpp[]),
          (err) => {
            this.manageError(err);
            reject(err);
          }
        );
    });
  }

  // Obtener actas por estado
  getActasByEstado(estado: string): Promise<ActaEntregaEpp[]> {
    return new Promise((resolve, reject) => {
      this.httpInt.get(`${this.end_point}estado/${estado}`)
        .subscribe(
          (res) => resolve(res as ActaEntregaEpp[]),
          (err) => {
            this.manageError(err);
            reject(err);
          }
        );
    });
  }

  // Generar número de acta automático
  generarNumeroActa(): Promise<{ numeroActa: string }> {
    return new Promise((resolve, reject) => {
      this.httpInt.get(`${this.end_point}generar-numero`)
        .subscribe(
          (res) => resolve(res as { numeroActa: string }),
          (err) => {
            this.manageError(err);
            reject(err);
          }
        );
    });
  }

  // Cambiar estado de la acta
  cambiarEstado(id: number, estado: string): Promise<ActaEntregaEpp> {
    return new Promise((resolve, reject) => {
      this.httpInt.put(`${this.end_point}${id}/estado`, { estado })
        .subscribe(
          (res) => resolve(res as ActaEntregaEpp),
          (err) => {
            this.manageError(err);
            reject(err);
          }
        );
    });
  }

  // Obtener solicitudes de EPP disponibles para entrega
  getSolicitudesDisponibles(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.httpInt.get(`${this.end_point}solicitudes-disponibles`)
        .subscribe(
          (res) => resolve(res as any[]),
          (err) => {
            this.manageError(err);
            reject(err);
          }
        );
    });
  }

  // Obtener detalles de solicitud aprobados
  getDetallesAprobados(idSolicitudEpp: number): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.httpInt.get(`${this.end_point}detalles-aprobados/${idSolicitudEpp}`)
        .subscribe(
          (res) => resolve(res as any[]),
          (err) => {
            this.manageError(err);
            reject(err);
          }
        );
    });
  }
} 